import React from 'react';
import PropTypes from 'prop-types';

const DeliveryOptionsInvalidLocation = ({ location, setView }) => {
  const handleRetry = () => {
    setView('location');
  };

  return (
    <>
      <section className="do-section ch-mb--4">
        <p className="do-question">Something went wrong</p>
        <p>
          Sorry, we couldn&apos;t find your postcode{' '}
          <span className="ch-fw--500">{location}</span>.
        </p>
        <p>Please check your details and try again.</p>
      </section>
      <button
        className="ch-btn ch-btn--block ch-btn--cta ch-mb--3"
        onClick={handleRetry}
        type="button"
      >
        Try again
      </button>
    </>
  );
};

export default DeliveryOptionsInvalidLocation;

DeliveryOptionsInvalidLocation.propTypes = {
  location: PropTypes.string,
  setView: PropTypes.func,
};
